import { render, staticRenderFns } from "./NewMessageAttachments.vue?vue&type=template&id=428f4826"
import script from "./NewMessageAttachments.vue?vue&type=script&lang=js"
export * from "./NewMessageAttachments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports